//App

import useForm from "../../../hooks/useForm";
import { CampaignContextData, CampaignProps } from "../../../../types/campaign";
import { CampaignReportContext } from "../CampaignsContainer";

const useCampaign = (props: CampaignProps) => {
  return useForm<CampaignContextData, CampaignProps>(
    CampaignReportContext,
    props
  );
};

export default useCampaign;
